
import Vue from 'vue'
import { v4 as uuid } from 'uuid'
import { mapGetters } from 'vuex'
import { VesselBay, VesselHatche } from "@/core/services/store/vesselMonitoring.types"
import VesselMonitoringBayHold from "./VesselMonitoringSingleBayHold.vue"
import VesselMonitoringBayDeck from '@/view/pages/vesselMonitoring/components/VesselMonitoringBay/VesselMonitoringBayDeck.vue'
import VesselMonitoringSingleBayDeck from "./VesselMonitoringSingleBayDeck.vue"
import VesselMonitoringSingleBayHold from "./VesselMonitoringSingleBayHold.vue"
import HatchCover from '@/components/HatchCover.vue'
import Crane from '@/components/Crane.vue'
import StackWeight from '@/components/StackWeight.vue'



interface Container {
  id: string
  x: number
  y: number
  width: number
  height: number
  fill: string
  stroke: string
  strokeWidth: number
  type: string
  isReefer: boolean
  is45Foot: boolean
  isTank: boolean
  isFlatRack: boolean
  isOpenTop: boolean
  isPlatform: boolean
}

export default Vue.extend({
  components: {
    VesselMonitoringBayHold,
    VesselMonitoringSingleBayHold,
    VesselMonitoringSingleBayDeck,
    HatchCover,
        Crane,
        StackWeight

  },
  props: {
    maxRows:{default:0},
       vesselHatch: { type: Object as () => any, default: () => ({ vesselBays: [] }) },
    vesselBay: {
      type: Object as () => VesselBay,
      default: () => ({
        vesselBayType: 1,
        sequense: 1,
        cellsCount: 0,
        vesselProfileHatchId: 1,
        bay: '001(002)',
        onDeck: {
          cols: 4,
          rows: 4,
          cells: [{
            containerNo: 1,
            containerCycleId: 1,
            lineOperator: 1,
            isoCode: 1,
            portOfDischarge: "sdf",
            color: "#ff00ff",
            existed: true,
            isReefer: true,
            is40Foot: false,
            is45Foot: false,
            isHazardous: false,
            isEmpty: false,
            isHighCube: false,
            isBreakBulk: false,
          }],
        },
        hold: {
          cols: 4,
          rows: 4,
          cells: [{ existed: true, isReefer: false, is45Foot: false }, { existed: false, isReefer: true }, { existed: true, isReefer: false, is45Foot: false }, { existed: true, isReefer: false, is45Foot: false },],
        },
      })
    },
    name: {
      default: '001(002)',
      type: String,
    },
    minDeckTiersNo: { default: 0 },
    minHoldTiersNo: { default: 0 },
  },
  data() {
    return {
      CELL_WIDTH: 20,
      deckKey: 'o',
      reeferImage: process.env.VUE_APP_BASE_URL + "media/svg/vesselProfile/Reefer.svg",
      textConfig: {
        fontSize: 10,
        fill: '#D0D0D0',
      },
    }
  },
  methods: {
    reeferConfig(container) {
      if (!(this.reeferImage instanceof HTMLImageElement)) {
        return {}
      }

      return {
        x: container.x,
        y: container.y,
        listening: false,
        width: this.CELL_WIDTH,
        height: this.CELL_WIDTH,
        image: this.reeferImage,
      }
    },
    getXLabels() {
      const labels: string[] = []
      const middle = this.data.cols % 2 === 0 ? this.data.cols / 2 : Math.floor(this.data.cols / 2)
      const startNumber = this.data.cols % 2 === 0 ? 1 : 0

      for (let i = 0; i < this.data.cols; i++) {
        if (this.data.cols % 2 === 0) {
          labels[middle + Math.floor((i * ((-1) ** i)) / 2)] = (i + 1).toString().padStart(2, '0')
        } else {
          labels[middle + Math.ceil((i * ((-1) ** (i - 1))) / 2)] = (startNumber + i).toString().padStart(2, '0')
        }
      }

      return labels.filter((label) => label !== undefined)
    }

    ,
    getYLabels() {
      const labels: (string | undefined)[] = []
      for (let i = this.data.rows - 1; i >= 0; i--) {
        labels.push((this.minDeckTiersNo + i * 2).toString())
      }
      return labels.filter((label) => label !== undefined) as string[]
    },
    getXLabelConfig(value: string, index: number) {
      return {
        text: value,
        x: 55 + index * this.CELL_WIDTH,
        y: 5,
        fontSize: 11,
        listening: false,
        fill: '#707070'
      }
    },
    getYLabelConfig(value: string, index: number) {
      return {
        text: value.toString(),
        x: this.data.cols * this.CELL_WIDTH + 55,
        y: 5 + this.CELL_WIDTH + index * this.CELL_WIDTH,
        fontSize: 11,
        listening: false,
        fill: '#707070'
      }
    },
    getYLabelConfigLeft(value: string, index: number) {
      return {
        text: value.toString(),
        x: 30,
        y: 5 + this.CELL_WIDTH + index * this.CELL_WIDTH,
        fontSize: 11,
        listening: false,
        fill: '#707070'
      }
    },
    getTextConfig(container: Container) {
      const text = container.isReefer ? 'RE' : container.is45Foot ? '45' : ''
      return {
        ...this.textConfig,
        text,
        x: container.x + 2,
        y: container.y + 2,
        listening: false,
      }
    },
  },
  computed: {
    ...mapGetters({
      selectedHatchData: 'getSelectedHatchData',
      selectedHatchIndex: 'getSelectedHatchIndex',
      selectedDeck: 'getSelectedDeck',
      getVesselMonitoringType :'getVesselMonitoringType'

    }),
    selectedHatchDatas() {
      return this.vesselHatch;
    },
    configKonva() {
      return {
        width: 100 + this.data.cols * this.CELL_WIDTH,
        height: this.data.rows * this.CELL_WIDTH + 20,
      }
    },
    containers() {
      const cols = this.data.cols
      const rows = this.data.rows
      const newContainers = this.data.cells.map((c, index) => {
        let fill
        switch (true) {
          case c.isReefer:
            fill = '#0aa' // replace with the actual color code
            break
          case c.is45Foot:
            fill = '#aaa' // replace with the actual color code
            break
          case c.isTank:
            fill = '#28A745' // replace with the actual color code
            break
          case c.isFlatRack:
            fill = '#FFC107' // replace with the actual color code
            break
          case c.isOpenTop:
            fill = '#DC3545' // replace with the actual color code
            break
          case c.isPlatform:
            fill = '#6610F2' // replace with the actual color code
            break
          default:
            fill = '#007BFF' // replace with the default color code
        }

        let cellData = {
          ...c,
          id: uuid(),
          index,
          x: (index % cols) * this.CELL_WIDTH + 50,
          y: (rows - 1 - Math.floor(index / cols)) * this.CELL_WIDTH + 20,
          width: this.CELL_WIDTH,
          height: this.CELL_WIDTH,
          fill: fill,
          stroke: '#A0A0A0',
          strokeWidth: 0.3,
          type: 'standard', // you might want to update this based on the container type
        }
        if ((this.getVesselMonitoringType === "Load" && c.isLoadedWrongPosition) || (this.getVesselMonitoringType === "Discharge" && c.yardPlanningIsObserved != null && !c.yardPlanningIsObserved)) {
          cellData = {
            ...cellData,
            strokeWidth: 3,
            fill: fill,
            stroke: 'red',
            //(c.blink ? 'blue' : 'yellow'),
            onmouseover: () => { },
            onmouseout: () => { }
          }
        }

        return cellData

      })
      return newContainers
    },

  },

  mounted() {
    const reeferImage = new window.Image()
    reeferImage.src = 'media/svg/vesselProfile/Reefer.svg'
    reeferImage.onload = () => {
      // set image only when it is loaded
      this.reeferImage = reeferImage
    }
  },


})
